var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgUser",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgUser{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "my",
    className: "svgUser svgBase svgHover svgSelect",
    d: "M13.4,5.3c0-3-2.4-5.5-5.5-5.5c-3,0-5.4,2.4-5.4,5.5c0,2,1,3.8,2.8,4.7c-2.3,0.9-4.1,3-4.5,5.4 c-0.1,0.3,0.1,0.7,0.5,0.7c0,0,0,0,0,0h0.1C1.7,16.2,2,16,2,15.7c0.6-2.8,3-4.9,5.9-5h0.1C11,10.7,13.5,8.3,13.4,5.3 C13.4,5.3,13.4,5.3,13.4,5.3z M3.8,5.3C3.8,2.9,5.7,1,8,1c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2H7.9C5.6,9.5,3.8,7.6,3.8,5.3 z M12,10.8c-0.3-0.2-0.7-0.1-0.8,0.2s-0.1,0.7,0.2,0.8c1.4,0.9,2.3,2.3,2.7,3.9c0.1,0.3,0.3,0.5,0.6,0.5h0.1 c0.3-0.1,0.5-0.4,0.5-0.7C14.8,13.5,13.6,11.8,12,10.8L12,10.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.663390f3.svg";
export { ForwardRef as ReactComponent };